import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AppProvider } from '../../context/AppContext';
import Layout from '../../components/Layout';

import Dashboard from '../Dashboard';
import Members from '../Members';
import MemberDetail from '../MemberDetail';
import Memberships from '../Memberships';
import Attendance from '../Attendance';
import PT from '../PT';
import Trainers from '../Trainers';
import Lockers from '../Lockers';
import Revenue from '../Revenue';
import Analytics from '../Analytics';
import Notifications from '../Notifications';
import Settings from '../Settings';
import Help from '../Help';

function AdminManageGymInner({ basePath }) {
  return (
    <Layout basePath={basePath}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="members" element={<Members />} />
        <Route path="members/:id" element={<MemberDetail />} />
        <Route path="memberships" element={<Memberships />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="pt" element={<PT />} />
        <Route path="trainers" element={<Trainers />} />
        <Route path="lockers" element={<Lockers />} />
        <Route path="revenue" element={<Revenue />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="settings" element={<Settings />} />
        <Route path="help" element={<Help />} />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </Layout>
  );
}

export default function AdminManageGym() {
  const { gymId } = useParams();
  const basePath = `/admin/gyms/${gymId}/manage`;

  return (
    <AppProvider adminGymId={gymId}>
      <AdminManageGymInner basePath={basePath} />
    </AppProvider>
  );
}
